export const SCREEN_SIZE = {
  XL: 1600,
  LG: 1280,
  MD: 992,
  SM: 768,
  XS: 576,
};
